// Single source of truth for the PropertyMakers brand.
//
// Derived from the client logo: navy-blue rooftops + "Makers", near-black
// "Property", warm-gold arc accents on white. To swap in the final logo
// artwork, drop the PNG at app/assets/images/brand/propertymakers-logo.png
// and set `useImageMark = true` below — nothing else needs to change.
export const BRAND = {
  name: "PropertyMakers",
  legalName: "Property Makers",
  tagline: "Your Dream Property Partner",
  domain: "propertymakers.com",
  appTitle: "PropertyMakers CRM",
  seoTitle: "PropertyMakers — Your Dream Property Partner",
  seoDescription:
    "PropertyMakers helps you find your dream home, plot, or commercial space. " +
    "Browse handpicked residential, commercial, and NA-plot properties with a partner you can trust.",

  // Palette lifted from the logo.
  colors: {
    navy: "#2C4A87", // rooftops + "Makers"
    navyDeep: "#1F3766", // hover / darker fills
    ink: "#1A1A1A", // "Property" text
    gold: "#B7975A", // arc accents
    goldSoft: "#CBB07B",
  },

  // Flip to true once the real PNG is present in app/assets/images/brand/.
  useImageMark: false,
};
